import { withClass, createPropFilter } from 'common/emotion'

import { WebLink, WebLinkProps } from 'common/navigation/web-link'

import {
    SponsoredLabel,
    Props as SponsoredLabelProps,
} from 'component-library/advertising/SponsoredLabel/SponsoredLabel'

import { calcRem } from 'component-library/__styling/style-functions'
import { colors, metrics } from 'component-library/__styling/settings'
import { transition } from 'component-library/__styling/style-mixins'

import { styledMediaClassName } from 'component-library/cards/CardMedia/StyledMedia.styled'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { CardTeaser } from 'component-library/cards/CardText/CardTeaser'
import styled from '@emotion/styled'

const styledSponsoredLabelClassName = 'LandscapeWideCard-SponsoredLabel'
const styledTextClassName = 'LandscapeWideCard-Text-Wrapper'
export const styledWrapperClassName = 'Card-Wrapper'

const margins = metrics.perthnow.margins
const sm = calcRem(margins.sm)
const textOffset = calcRem(metrics.perthnow.cards.textOffset)

export type StyledWrapperProps = { isLoading: boolean }

export const StyledWrapper = withClass(styledWrapperClassName)(
    styled(WebLink, { shouldForwardProp: createPropFilter<WebLinkProps>()(['isLoading']) })<
        StyledWrapperProps
    >(
        {
            color: colors.thewest.greyGorilla,
            lineHeight: 1.375,
            display: 'flex',
            flex: '1 3 200px',
            textDecoration: 'none',
            flexWrap: 'wrap',
            transform: `translateY(${-textOffset})`, // offset for font alignment
            alignItems: 'flex-start',
            ...transition({ properties: ['color'] }),

            '&:focus': {
                outline: 'none',

                [`& .${styledMediaClassName}`]: {
                    '&::after': {
                        borderColor: colors.white50,
                    },
                },
            },
        },
        (props: StyledWrapperProps) => ({
            ...conditionalStyles(props.isLoading, {
                cursor: 'default',
            }),
        })
    )
)

export const StyledText = withClass(styledTextClassName)(
    styled('div')({
        flex: '1 1 200px',
    })
)

export const StyledTeaser = styled(CardTeaser)({
    flex: '1 1 200px',
    fontSize: calcRem(14),
})

export const StyledSponsoredLabel = withClass(styledSponsoredLabelClassName)(
    styled(SponsoredLabel)<SponsoredLabelProps>(
        {
            alignSelf: 'flex-start',
            color: colors.perthnow.greySlate,
            display: 'inline-block',
            fontSize: calcRem(12),
        },
        ({ theme }) => ({
            fontFamily: theme.fonts.sansSerifCond,
        })
    )
)

export const StyledSponsoredByline = styled('span')(
    {
        fontWeight: 400,
        fontSize: calcRem(13),
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: sm,
    },
    ({ theme }) => ({
        fontFamily: theme.fonts.sansSerifCond,
    })
)
